// source: fitness-service/v1/agency.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var fitness$service_v1_common_pb = require('../../fitness-service/v1/common_pb.js');
goog.object.extend(proto, fitness$service_v1_common_pb);
goog.exportSymbol('proto.fitness.service.v1.ActivateTrainerAccountRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.AgencyProfile', null, global);
goog.exportSymbol('proto.fitness.service.v1.AgencyProfileResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.CreateTrainerAccountRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.DeactivateTrainerAccountRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetAgencyAllTrainersRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetAgencyAllTrainersResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetAgencyProfileRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetAgencySingleTrainerRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetAgencySingleTrainerResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.TrainerAccountResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.TrainerWithClients', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateAgencyProfileRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.CreateTrainerAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.CreateTrainerAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.CreateTrainerAccountRequest.displayName = 'proto.fitness.service.v1.CreateTrainerAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.TrainerAccountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.TrainerAccountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.TrainerAccountResponse.displayName = 'proto.fitness.service.v1.TrainerAccountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetAgencySingleTrainerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetAgencySingleTrainerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetAgencySingleTrainerRequest.displayName = 'proto.fitness.service.v1.GetAgencySingleTrainerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetAgencySingleTrainerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetAgencySingleTrainerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetAgencySingleTrainerResponse.displayName = 'proto.fitness.service.v1.GetAgencySingleTrainerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetAgencyAllTrainersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetAgencyAllTrainersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetAgencyAllTrainersRequest.displayName = 'proto.fitness.service.v1.GetAgencyAllTrainersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetAgencyAllTrainersResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetAgencyAllTrainersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetAgencyAllTrainersResponse.displayName = 'proto.fitness.service.v1.GetAgencyAllTrainersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetAgencyProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetAgencyProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetAgencyProfileRequest.displayName = 'proto.fitness.service.v1.GetAgencyProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.AgencyProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.AgencyProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.AgencyProfile.displayName = 'proto.fitness.service.v1.AgencyProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.AgencyProfileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.AgencyProfileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.AgencyProfileResponse.displayName = 'proto.fitness.service.v1.AgencyProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.UpdateAgencyProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateAgencyProfileRequest.displayName = 'proto.fitness.service.v1.UpdateAgencyProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.DeactivateTrainerAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.DeactivateTrainerAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.DeactivateTrainerAccountRequest.displayName = 'proto.fitness.service.v1.DeactivateTrainerAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.ActivateTrainerAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.ActivateTrainerAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.ActivateTrainerAccountRequest.displayName = 'proto.fitness.service.v1.ActivateTrainerAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.displayName = 'proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.displayName = 'proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.TrainerWithClients = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.TrainerWithClients.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.TrainerWithClients, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.TrainerWithClients.displayName = 'proto.fitness.service.v1.TrainerWithClients';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.CreateTrainerAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.CreateTrainerAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
password: jspb.Message.getFieldWithDefault(msg, 3, ""),
phone: jspb.Message.getFieldWithDefault(msg, 4, ""),
specialization: jspb.Message.getFieldWithDefault(msg, 5, ""),
certification: jspb.Message.getFieldWithDefault(msg, 6, ""),
experienceYears: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.CreateTrainerAccountRequest}
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.CreateTrainerAccountRequest;
  return proto.fitness.service.v1.CreateTrainerAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.CreateTrainerAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.CreateTrainerAccountRequest}
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPassword(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPhone(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSpecialization(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCertification(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExperienceYears(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.CreateTrainerAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.CreateTrainerAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSpecialization();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCertification();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getExperienceYears();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateTrainerAccountRequest} returns this
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateTrainerAccountRequest} returns this
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateTrainerAccountRequest} returns this
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string phone = 4;
 * @return {string}
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateTrainerAccountRequest} returns this
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string specialization = 5;
 * @return {string}
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.getSpecialization = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateTrainerAccountRequest} returns this
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.setSpecialization = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string certification = 6;
 * @return {string}
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.getCertification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateTrainerAccountRequest} returns this
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.setCertification = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 experience_years = 7;
 * @return {number}
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.getExperienceYears = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.CreateTrainerAccountRequest} returns this
 */
proto.fitness.service.v1.CreateTrainerAccountRequest.prototype.setExperienceYears = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.TrainerAccountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.TrainerAccountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.TrainerAccountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.TrainerAccountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
trainerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
accessToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
refreshToken: jspb.Message.getFieldWithDefault(msg, 4, ""),
trainerProfile: (f = msg.getTrainerProfile()) && fitness$service_v1_common_pb.TrainerProfile.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.TrainerAccountResponse}
 */
proto.fitness.service.v1.TrainerAccountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.TrainerAccountResponse;
  return proto.fitness.service.v1.TrainerAccountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.TrainerAccountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.TrainerAccountResponse}
 */
proto.fitness.service.v1.TrainerAccountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTrainerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAccessToken(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRefreshToken(value);
      break;
    case 5:
      var value = new fitness$service_v1_common_pb.TrainerProfile;
      reader.readMessage(value,fitness$service_v1_common_pb.TrainerProfile.deserializeBinaryFromReader);
      msg.setTrainerProfile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.TrainerAccountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.TrainerAccountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.TrainerAccountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.TrainerAccountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrainerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccessToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRefreshToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTrainerProfile();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fitness$service_v1_common_pb.TrainerProfile.serializeBinaryToWriter
    );
  }
};


/**
 * optional string trainer_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.TrainerAccountResponse.prototype.getTrainerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerAccountResponse} returns this
 */
proto.fitness.service.v1.TrainerAccountResponse.prototype.setTrainerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.TrainerAccountResponse.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerAccountResponse} returns this
 */
proto.fitness.service.v1.TrainerAccountResponse.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string access_token = 3;
 * @return {string}
 */
proto.fitness.service.v1.TrainerAccountResponse.prototype.getAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerAccountResponse} returns this
 */
proto.fitness.service.v1.TrainerAccountResponse.prototype.setAccessToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string refresh_token = 4;
 * @return {string}
 */
proto.fitness.service.v1.TrainerAccountResponse.prototype.getRefreshToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerAccountResponse} returns this
 */
proto.fitness.service.v1.TrainerAccountResponse.prototype.setRefreshToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional TrainerProfile trainer_profile = 5;
 * @return {?proto.fitness.service.v1.TrainerProfile}
 */
proto.fitness.service.v1.TrainerAccountResponse.prototype.getTrainerProfile = function() {
  return /** @type{?proto.fitness.service.v1.TrainerProfile} */ (
    jspb.Message.getWrapperField(this, fitness$service_v1_common_pb.TrainerProfile, 5));
};


/**
 * @param {?proto.fitness.service.v1.TrainerProfile|undefined} value
 * @return {!proto.fitness.service.v1.TrainerAccountResponse} returns this
*/
proto.fitness.service.v1.TrainerAccountResponse.prototype.setTrainerProfile = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.TrainerAccountResponse} returns this
 */
proto.fitness.service.v1.TrainerAccountResponse.prototype.clearTrainerProfile = function() {
  return this.setTrainerProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.TrainerAccountResponse.prototype.hasTrainerProfile = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetAgencySingleTrainerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetAgencySingleTrainerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetAgencySingleTrainerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencySingleTrainerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
trainerId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetAgencySingleTrainerRequest}
 */
proto.fitness.service.v1.GetAgencySingleTrainerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetAgencySingleTrainerRequest;
  return proto.fitness.service.v1.GetAgencySingleTrainerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetAgencySingleTrainerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetAgencySingleTrainerRequest}
 */
proto.fitness.service.v1.GetAgencySingleTrainerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTrainerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetAgencySingleTrainerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetAgencySingleTrainerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetAgencySingleTrainerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencySingleTrainerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrainerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string trainer_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GetAgencySingleTrainerRequest.prototype.getTrainerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetAgencySingleTrainerRequest} returns this
 */
proto.fitness.service.v1.GetAgencySingleTrainerRequest.prototype.setTrainerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetAgencySingleTrainerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetAgencySingleTrainerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetAgencySingleTrainerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencySingleTrainerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
trainer: (f = msg.getTrainer()) && fitness$service_v1_common_pb.TrainerProfile.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetAgencySingleTrainerResponse}
 */
proto.fitness.service.v1.GetAgencySingleTrainerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetAgencySingleTrainerResponse;
  return proto.fitness.service.v1.GetAgencySingleTrainerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetAgencySingleTrainerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetAgencySingleTrainerResponse}
 */
proto.fitness.service.v1.GetAgencySingleTrainerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fitness$service_v1_common_pb.TrainerProfile;
      reader.readMessage(value,fitness$service_v1_common_pb.TrainerProfile.deserializeBinaryFromReader);
      msg.setTrainer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetAgencySingleTrainerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetAgencySingleTrainerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetAgencySingleTrainerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencySingleTrainerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrainer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fitness$service_v1_common_pb.TrainerProfile.serializeBinaryToWriter
    );
  }
};


/**
 * optional TrainerProfile trainer = 1;
 * @return {?proto.fitness.service.v1.TrainerProfile}
 */
proto.fitness.service.v1.GetAgencySingleTrainerResponse.prototype.getTrainer = function() {
  return /** @type{?proto.fitness.service.v1.TrainerProfile} */ (
    jspb.Message.getWrapperField(this, fitness$service_v1_common_pb.TrainerProfile, 1));
};


/**
 * @param {?proto.fitness.service.v1.TrainerProfile|undefined} value
 * @return {!proto.fitness.service.v1.GetAgencySingleTrainerResponse} returns this
*/
proto.fitness.service.v1.GetAgencySingleTrainerResponse.prototype.setTrainer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetAgencySingleTrainerResponse} returns this
 */
proto.fitness.service.v1.GetAgencySingleTrainerResponse.prototype.clearTrainer = function() {
  return this.setTrainer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetAgencySingleTrainerResponse.prototype.hasTrainer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetAgencyAllTrainersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetAgencyAllTrainersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetAgencyAllTrainersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencyAllTrainersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
activeOnly: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetAgencyAllTrainersRequest}
 */
proto.fitness.service.v1.GetAgencyAllTrainersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetAgencyAllTrainersRequest;
  return proto.fitness.service.v1.GetAgencyAllTrainersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetAgencyAllTrainersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetAgencyAllTrainersRequest}
 */
proto.fitness.service.v1.GetAgencyAllTrainersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActiveOnly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetAgencyAllTrainersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetAgencyAllTrainersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetAgencyAllTrainersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencyAllTrainersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getActiveOnly();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.fitness.service.v1.GetAgencyAllTrainersRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAgencyAllTrainersRequest} returns this
 */
proto.fitness.service.v1.GetAgencyAllTrainersRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetAgencyAllTrainersRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAgencyAllTrainersRequest} returns this
 */
proto.fitness.service.v1.GetAgencyAllTrainersRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool active_only = 3;
 * @return {boolean}
 */
proto.fitness.service.v1.GetAgencyAllTrainersRequest.prototype.getActiveOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.GetAgencyAllTrainersRequest} returns this
 */
proto.fitness.service.v1.GetAgencyAllTrainersRequest.prototype.setActiveOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetAgencyAllTrainersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetAgencyAllTrainersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
trainersList: jspb.Message.toObjectList(msg.getTrainersList(),
    fitness$service_v1_common_pb.TrainerProfile.toObject, includeInstance),
totalCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetAgencyAllTrainersResponse}
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetAgencyAllTrainersResponse;
  return proto.fitness.service.v1.GetAgencyAllTrainersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetAgencyAllTrainersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetAgencyAllTrainersResponse}
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fitness$service_v1_common_pb.TrainerProfile;
      reader.readMessage(value,fitness$service_v1_common_pb.TrainerProfile.deserializeBinaryFromReader);
      msg.addTrainers(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetAgencyAllTrainersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetAgencyAllTrainersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrainersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      fitness$service_v1_common_pb.TrainerProfile.serializeBinaryToWriter
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated TrainerProfile trainers = 1;
 * @return {!Array<!proto.fitness.service.v1.TrainerProfile>}
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.prototype.getTrainersList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.TrainerProfile>} */ (
    jspb.Message.getRepeatedWrapperField(this, fitness$service_v1_common_pb.TrainerProfile, 1));
};


/**
 * @param {!Array<!proto.fitness.service.v1.TrainerProfile>} value
 * @return {!proto.fitness.service.v1.GetAgencyAllTrainersResponse} returns this
*/
proto.fitness.service.v1.GetAgencyAllTrainersResponse.prototype.setTrainersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fitness.service.v1.TrainerProfile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.TrainerProfile}
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.prototype.addTrainers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fitness.service.v1.TrainerProfile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetAgencyAllTrainersResponse} returns this
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.prototype.clearTrainersList = function() {
  return this.setTrainersList([]);
};


/**
 * optional int32 total_count = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAgencyAllTrainersResponse} returns this
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAgencyAllTrainersResponse} returns this
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAgencyAllTrainersResponse} returns this
 */
proto.fitness.service.v1.GetAgencyAllTrainersResponse.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetAgencyProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetAgencyProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetAgencyProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencyProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetAgencyProfileRequest}
 */
proto.fitness.service.v1.GetAgencyProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetAgencyProfileRequest;
  return proto.fitness.service.v1.GetAgencyProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetAgencyProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetAgencyProfileRequest}
 */
proto.fitness.service.v1.GetAgencyProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetAgencyProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetAgencyProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetAgencyProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencyProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.AgencyProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.AgencyProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.AgencyProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AgencyProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
address: jspb.Message.getFieldWithDefault(msg, 4, ""),
contactPhone: jspb.Message.getFieldWithDefault(msg, 5, ""),
contactEmail: jspb.Message.getFieldWithDefault(msg, 6, ""),
isActive: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
trainerCount: jspb.Message.getFieldWithDefault(msg, 9, 0),
brandingEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
brandName: jspb.Message.getFieldWithDefault(msg, 11, ""),
brandLogoUrl: jspb.Message.getFieldWithDefault(msg, 12, ""),
brandPrimaryColor: jspb.Message.getFieldWithDefault(msg, 13, ""),
brandSupportEmail: jspb.Message.getFieldWithDefault(msg, 14, ""),
isIndependent: jspb.Message.getBooleanFieldWithDefault(msg, 15, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.AgencyProfile}
 */
proto.fitness.service.v1.AgencyProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.AgencyProfile;
  return proto.fitness.service.v1.AgencyProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.AgencyProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.AgencyProfile}
 */
proto.fitness.service.v1.AgencyProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAddress(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContactPhone(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContactEmail(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrainerCount(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBrandingEnabled(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBrandName(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBrandLogoUrl(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBrandPrimaryColor(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBrandSupportEmail(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsIndependent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.AgencyProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.AgencyProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.AgencyProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AgencyProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getContactPhone();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getContactEmail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTrainerCount();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getBrandingEnabled();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getBrandName();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getBrandLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getBrandPrimaryColor();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getBrandSupportEmail();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getIsIndependent();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fitness.service.v1.AgencyProfile.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
 */
proto.fitness.service.v1.AgencyProfile.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.fitness.service.v1.AgencyProfile.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
 */
proto.fitness.service.v1.AgencyProfile.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.fitness.service.v1.AgencyProfile.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
 */
proto.fitness.service.v1.AgencyProfile.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string address = 4;
 * @return {string}
 */
proto.fitness.service.v1.AgencyProfile.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
 */
proto.fitness.service.v1.AgencyProfile.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string contact_phone = 5;
 * @return {string}
 */
proto.fitness.service.v1.AgencyProfile.prototype.getContactPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
 */
proto.fitness.service.v1.AgencyProfile.prototype.setContactPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string contact_email = 6;
 * @return {string}
 */
proto.fitness.service.v1.AgencyProfile.prototype.getContactEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
 */
proto.fitness.service.v1.AgencyProfile.prototype.setContactEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool is_active = 7;
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyProfile.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
 */
proto.fitness.service.v1.AgencyProfile.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.AgencyProfile.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
*/
proto.fitness.service.v1.AgencyProfile.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
 */
proto.fitness.service.v1.AgencyProfile.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyProfile.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 trainer_count = 9;
 * @return {number}
 */
proto.fitness.service.v1.AgencyProfile.prototype.getTrainerCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
 */
proto.fitness.service.v1.AgencyProfile.prototype.setTrainerCount = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool branding_enabled = 10;
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyProfile.prototype.getBrandingEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
 */
proto.fitness.service.v1.AgencyProfile.prototype.setBrandingEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string brand_name = 11;
 * @return {string}
 */
proto.fitness.service.v1.AgencyProfile.prototype.getBrandName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
 */
proto.fitness.service.v1.AgencyProfile.prototype.setBrandName = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string brand_logo_url = 12;
 * @return {string}
 */
proto.fitness.service.v1.AgencyProfile.prototype.getBrandLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
 */
proto.fitness.service.v1.AgencyProfile.prototype.setBrandLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string brand_primary_color = 13;
 * @return {string}
 */
proto.fitness.service.v1.AgencyProfile.prototype.getBrandPrimaryColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
 */
proto.fitness.service.v1.AgencyProfile.prototype.setBrandPrimaryColor = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string brand_support_email = 14;
 * @return {string}
 */
proto.fitness.service.v1.AgencyProfile.prototype.getBrandSupportEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
 */
proto.fitness.service.v1.AgencyProfile.prototype.setBrandSupportEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional bool is_independent = 15;
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyProfile.prototype.getIsIndependent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.AgencyProfile} returns this
 */
proto.fitness.service.v1.AgencyProfile.prototype.setIsIndependent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.AgencyProfileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.AgencyProfileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.AgencyProfileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AgencyProfileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
agency: (f = msg.getAgency()) && proto.fitness.service.v1.AgencyProfile.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.AgencyProfileResponse}
 */
proto.fitness.service.v1.AgencyProfileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.AgencyProfileResponse;
  return proto.fitness.service.v1.AgencyProfileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.AgencyProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.AgencyProfileResponse}
 */
proto.fitness.service.v1.AgencyProfileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.AgencyProfile;
      reader.readMessage(value,proto.fitness.service.v1.AgencyProfile.deserializeBinaryFromReader);
      msg.setAgency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.AgencyProfileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.AgencyProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.AgencyProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AgencyProfileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAgency();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.AgencyProfile.serializeBinaryToWriter
    );
  }
};


/**
 * optional AgencyProfile agency = 1;
 * @return {?proto.fitness.service.v1.AgencyProfile}
 */
proto.fitness.service.v1.AgencyProfileResponse.prototype.getAgency = function() {
  return /** @type{?proto.fitness.service.v1.AgencyProfile} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.AgencyProfile, 1));
};


/**
 * @param {?proto.fitness.service.v1.AgencyProfile|undefined} value
 * @return {!proto.fitness.service.v1.AgencyProfileResponse} returns this
*/
proto.fitness.service.v1.AgencyProfileResponse.prototype.setAgency = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.AgencyProfileResponse} returns this
 */
proto.fitness.service.v1.AgencyProfileResponse.prototype.clearAgency = function() {
  return this.setAgency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.AgencyProfileResponse.prototype.hasAgency = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateAgencyProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateAgencyProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
description: jspb.Message.getFieldWithDefault(msg, 2, ""),
address: jspb.Message.getFieldWithDefault(msg, 3, ""),
contactPhone: jspb.Message.getFieldWithDefault(msg, 4, ""),
contactEmail: jspb.Message.getFieldWithDefault(msg, 5, ""),
brandName: jspb.Message.getFieldWithDefault(msg, 6, ""),
brandLogoUrl: jspb.Message.getFieldWithDefault(msg, 7, ""),
brandPrimaryColor: jspb.Message.getFieldWithDefault(msg, 8, ""),
brandSupportEmail: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateAgencyProfileRequest}
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateAgencyProfileRequest;
  return proto.fitness.service.v1.UpdateAgencyProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateAgencyProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateAgencyProfileRequest}
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAddress(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContactPhone(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContactEmail(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBrandName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBrandLogoUrl(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBrandPrimaryColor(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBrandSupportEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateAgencyProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateAgencyProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContactPhone();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getContactEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBrandName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBrandLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBrandPrimaryColor();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getBrandSupportEmail();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateAgencyProfileRequest} returns this
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateAgencyProfileRequest} returns this
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string address = 3;
 * @return {string}
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateAgencyProfileRequest} returns this
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string contact_phone = 4;
 * @return {string}
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.getContactPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateAgencyProfileRequest} returns this
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.setContactPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string contact_email = 5;
 * @return {string}
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.getContactEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateAgencyProfileRequest} returns this
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.setContactEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string brand_name = 6;
 * @return {string}
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.getBrandName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateAgencyProfileRequest} returns this
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.setBrandName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string brand_logo_url = 7;
 * @return {string}
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.getBrandLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateAgencyProfileRequest} returns this
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.setBrandLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string brand_primary_color = 8;
 * @return {string}
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.getBrandPrimaryColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateAgencyProfileRequest} returns this
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.setBrandPrimaryColor = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string brand_support_email = 9;
 * @return {string}
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.getBrandSupportEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateAgencyProfileRequest} returns this
 */
proto.fitness.service.v1.UpdateAgencyProfileRequest.prototype.setBrandSupportEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.DeactivateTrainerAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.DeactivateTrainerAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.DeactivateTrainerAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeactivateTrainerAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
trainerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
reason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.DeactivateTrainerAccountRequest}
 */
proto.fitness.service.v1.DeactivateTrainerAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.DeactivateTrainerAccountRequest;
  return proto.fitness.service.v1.DeactivateTrainerAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.DeactivateTrainerAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.DeactivateTrainerAccountRequest}
 */
proto.fitness.service.v1.DeactivateTrainerAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTrainerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.DeactivateTrainerAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.DeactivateTrainerAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.DeactivateTrainerAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeactivateTrainerAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrainerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string trainer_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.DeactivateTrainerAccountRequest.prototype.getTrainerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DeactivateTrainerAccountRequest} returns this
 */
proto.fitness.service.v1.DeactivateTrainerAccountRequest.prototype.setTrainerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.fitness.service.v1.DeactivateTrainerAccountRequest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DeactivateTrainerAccountRequest} returns this
 */
proto.fitness.service.v1.DeactivateTrainerAccountRequest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.ActivateTrainerAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.ActivateTrainerAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.ActivateTrainerAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ActivateTrainerAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
trainerId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.ActivateTrainerAccountRequest}
 */
proto.fitness.service.v1.ActivateTrainerAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.ActivateTrainerAccountRequest;
  return proto.fitness.service.v1.ActivateTrainerAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.ActivateTrainerAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.ActivateTrainerAccountRequest}
 */
proto.fitness.service.v1.ActivateTrainerAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTrainerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.ActivateTrainerAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.ActivateTrainerAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.ActivateTrainerAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ActivateTrainerAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrainerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string trainer_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.ActivateTrainerAccountRequest.prototype.getTrainerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.ActivateTrainerAccountRequest} returns this
 */
proto.fitness.service.v1.ActivateTrainerAccountRequest.prototype.setTrainerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
activeOnly: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
trainerId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest;
  return proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActiveOnly(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTrainerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getActiveOnly();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTrainerId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest} returns this
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest} returns this
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool active_only = 3;
 * @return {boolean}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.prototype.getActiveOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest} returns this
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.prototype.setActiveOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string trainer_id = 4;
 * @return {string}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.prototype.getTrainerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest} returns this
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest.prototype.setTrainerId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
trainerRelationsList: jspb.Message.toObjectList(msg.getTrainerRelationsList(),
    proto.fitness.service.v1.TrainerWithClients.toObject, includeInstance),
totalCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse;
  return proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.TrainerWithClients;
      reader.readMessage(value,proto.fitness.service.v1.TrainerWithClients.deserializeBinaryFromReader);
      msg.addTrainerRelations(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrainerRelationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fitness.service.v1.TrainerWithClients.serializeBinaryToWriter
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated TrainerWithClients trainer_relations = 1;
 * @return {!Array<!proto.fitness.service.v1.TrainerWithClients>}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.prototype.getTrainerRelationsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.TrainerWithClients>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.TrainerWithClients, 1));
};


/**
 * @param {!Array<!proto.fitness.service.v1.TrainerWithClients>} value
 * @return {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse} returns this
*/
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.prototype.setTrainerRelationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fitness.service.v1.TrainerWithClients=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.TrainerWithClients}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.prototype.addTrainerRelations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fitness.service.v1.TrainerWithClients, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse} returns this
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.prototype.clearTrainerRelationsList = function() {
  return this.setTrainerRelationsList([]);
};


/**
 * optional int32 total_count = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse} returns this
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse} returns this
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse} returns this
 */
proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.TrainerWithClients.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.TrainerWithClients.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.TrainerWithClients.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.TrainerWithClients} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.TrainerWithClients.toObject = function(includeInstance, msg) {
  var f, obj = {
trainer: (f = msg.getTrainer()) && fitness$service_v1_common_pb.TrainerProfile.toObject(includeInstance, f),
clientRelationsList: jspb.Message.toObjectList(msg.getClientRelationsList(),
    fitness$service_v1_common_pb.TrainerClientRelation.toObject, includeInstance),
activeClientCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalClientCount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.TrainerWithClients}
 */
proto.fitness.service.v1.TrainerWithClients.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.TrainerWithClients;
  return proto.fitness.service.v1.TrainerWithClients.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.TrainerWithClients} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.TrainerWithClients}
 */
proto.fitness.service.v1.TrainerWithClients.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fitness$service_v1_common_pb.TrainerProfile;
      reader.readMessage(value,fitness$service_v1_common_pb.TrainerProfile.deserializeBinaryFromReader);
      msg.setTrainer(value);
      break;
    case 2:
      var value = new fitness$service_v1_common_pb.TrainerClientRelation;
      reader.readMessage(value,fitness$service_v1_common_pb.TrainerClientRelation.deserializeBinaryFromReader);
      msg.addClientRelations(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActiveClientCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalClientCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.TrainerWithClients.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.TrainerWithClients.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.TrainerWithClients} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.TrainerWithClients.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrainer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fitness$service_v1_common_pb.TrainerProfile.serializeBinaryToWriter
    );
  }
  f = message.getClientRelationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      fitness$service_v1_common_pb.TrainerClientRelation.serializeBinaryToWriter
    );
  }
  f = message.getActiveClientCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalClientCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional TrainerProfile trainer = 1;
 * @return {?proto.fitness.service.v1.TrainerProfile}
 */
proto.fitness.service.v1.TrainerWithClients.prototype.getTrainer = function() {
  return /** @type{?proto.fitness.service.v1.TrainerProfile} */ (
    jspb.Message.getWrapperField(this, fitness$service_v1_common_pb.TrainerProfile, 1));
};


/**
 * @param {?proto.fitness.service.v1.TrainerProfile|undefined} value
 * @return {!proto.fitness.service.v1.TrainerWithClients} returns this
*/
proto.fitness.service.v1.TrainerWithClients.prototype.setTrainer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.TrainerWithClients} returns this
 */
proto.fitness.service.v1.TrainerWithClients.prototype.clearTrainer = function() {
  return this.setTrainer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.TrainerWithClients.prototype.hasTrainer = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TrainerClientRelation client_relations = 2;
 * @return {!Array<!proto.fitness.service.v1.TrainerClientRelation>}
 */
proto.fitness.service.v1.TrainerWithClients.prototype.getClientRelationsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.TrainerClientRelation>} */ (
    jspb.Message.getRepeatedWrapperField(this, fitness$service_v1_common_pb.TrainerClientRelation, 2));
};


/**
 * @param {!Array<!proto.fitness.service.v1.TrainerClientRelation>} value
 * @return {!proto.fitness.service.v1.TrainerWithClients} returns this
*/
proto.fitness.service.v1.TrainerWithClients.prototype.setClientRelationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.fitness.service.v1.TrainerClientRelation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.TrainerClientRelation}
 */
proto.fitness.service.v1.TrainerWithClients.prototype.addClientRelations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fitness.service.v1.TrainerClientRelation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.TrainerWithClients} returns this
 */
proto.fitness.service.v1.TrainerWithClients.prototype.clearClientRelationsList = function() {
  return this.setClientRelationsList([]);
};


/**
 * optional int32 active_client_count = 3;
 * @return {number}
 */
proto.fitness.service.v1.TrainerWithClients.prototype.getActiveClientCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.TrainerWithClients} returns this
 */
proto.fitness.service.v1.TrainerWithClients.prototype.setActiveClientCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 total_client_count = 4;
 * @return {number}
 */
proto.fitness.service.v1.TrainerWithClients.prototype.getTotalClientCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.TrainerWithClients} returns this
 */
proto.fitness.service.v1.TrainerWithClients.prototype.setTotalClientCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


goog.object.extend(exports, proto.fitness.service.v1);
